//
import Model from '@/models/Model'
import DetailPurchaseOrderModel from '@/models/Purchase/PchDetailPurchaseOrder'
import InvoiceNumberModel from '@/models/Actions/AInvoiceNumber'
import PurchaseInvoiceModel from '@/models/Purchase/PchPurchaseInvoice'

/**
 * This class describes a pch purchase order.
 *
 * @class      PchPurchaseOrder (name)
 */
export default class PchPurchaseOrder extends Model {

  //
  selected = []

  //
  //static appends = ['not_received_days']
  
  //
  static includes = [
    'available_pch_purchase_order_has_invoice_numbers',
    'pch_payment_condition',
    'pch_purchase_order_has_invoice_numbers.pch_purchase_invoice',
    'pch_provider',
    'pch_provider_branch_offices',
    'g_originator_user.hr_employee',
    'pch_purchase_order_state',
  ]

  selected_global_discount_amount = 0

  /**
   * 
   */
  get pch_provider_rut() {
    return this.getProperty('pch_provider.rut', '')
  }

  /**
   *
   */
  get has_selected() {
      return Array.isArray(this.selected)
  }

  /**
   *
   */
  get invoice_numbers() {
      return this.pch_purchase_order_has_invoice_numbers.map(
          this.mapInvoiceNumber
      )
  }

  /**
   *
   */
  get invoice_numbers_ids() {
      return this.pch_purchase_order_has_invoice_numbers.map(
          this.mapInvoiceNumberId
      )
  }

  /**
   *
   */
  get invoice_numbers_ids_pop() {
      return this.invoice_numbers_ids.slice().pop()
  }

  /**
   *
   */
  get invoice_numbers_pop() {
      return this.invoice_numbers.slice().pop()
  }

  /**
   * { property_description }
   *
   * @type       {boolean}
   */
  get pch_payment_condition_type() {
      return this.pch_payment_condition ? this.pch_payment_condition.type : '-'
  }

  /**
   * { property_description }
   *
   * @type       {<type>}
   */
  get pch_payment_condition_type_prefix() {
      return this.pch_payment_condition_type.split(' ').shift()
  }

  /**
   * { property_description }
   *
   * @type       {<type>}
   */
  get pch_payment_condition_sum() {
      return isNaN(this.pch_payment_condition_type_prefix) ? 0 : Number(this.pch_payment_condition_type_prefix)
  }

  /**
   *
   */
  get pch_provider_branch_offices_address() {
      return this.pch_provider_branch_offices
          ? this.pch_provider_branch_offices.address
          : '-'
  }

  /**
   *
   */
  get pch_provider_business_name() {
      return this.pch_provider ? this.pch_provider.business_name : '-'
  }

  /**
   *
   */
  get originator_user_name() {
      return this.g_originator_user.hr_employee
          ? `${this.g_originator_user.hr_employee.names} ${this.g_originator_user.hr_employee.last_name1}`
          : '-'
  }

  /**
   *
   */
  get authorizer_user_name() {
      return this.g_authorizer_user.hr_employee
          ? `${this.g_authorizer_user.hr_employee.names} ${this.g_authorizer_user.hr_employee.last_name1}`
          : '-'
  }
  /**
   * Get Purchase Order State Name
   * @type {String}
   */
  get pch_order_state_name() {
    return this.getProperty('pch_purchase_order_state.state', '-')
  }
  /**
   * Get Purchase Order Warehouse
   * @type {String}
   */
  get wh_warehouse_name() {
    return this.getProperty('wh_warehouse.name', '-')
  }
  /**
   * Get Purchase Order Subtotal
   * @type {Number}
   */
  get selected_new_net_subtotal() {

    // required data
    const newGlobalDiscountAmount = this.getProperty('selected_global_discount_amount', 0)
    const newNetSubtotal = this.getProperty('selected_net_subtotal', 0)
    const newSubtotal = newNetSubtotal * (( 100 - newGlobalDiscountAmount ) / 100)

    // new subtotal
    return Math.round(newSubtotal)
    //return Math.round(this.selected_net_subtotal * ((100-this.selected_global_discount_amount)/100))
  }
  /**
   * Get Purchase Order IVA.
   * @type {Number}
   */
  get selected_iva() {

    // required data
    const newNetSubtotal = this.getProperty('selected_new_net_subtotal', 0)
    const newExent = this.getProperty('is_exent', false)
    const iva = newExent ? 0 : 0.19

    // new iva
    return Math.ceil(newNetSubtotal * iva)
  }
  /**
   * Get Purchase Order Total
   * @type {Number}
   */
  get selected_total() {

    // required data
    const newNetSubtotal = this.getProperty('selected_new_net_subtotal', 0)
    const newExtraTotal = this.getProperty('extra_total', 0)
    const newExent = this.getProperty('is_exent', false)
    const iva = newExent ? 1 : 1.19 

    // new total
    return Math.ceil(Number(newNetSubtotal) * iva) + Number(newExtraTotal)
  }
  /**
   * Get Purchase Order Net Subtotal
   * @type {Number}
   */
  get selected_net_subtotal() {
    return this.getProperty('selected', []).reduce(this.reduceNetSubtotal, 0)
  }
  /**
   * 
   */
  set selected_net_subtotal(val) {}
  /**
   * 
   */
  set selected_iva(val) {}
  /**
   * 
   */
  set selected_total(val) {}
  /**
   * Get Purchase Order Selected Invoice Number
   * @type {String}
   */
  get invoice_number_selected() {
    return this.getProperty('available_pch_purchase_order_has_invoice_numbers', []).reduce(this.reduceInvoiceNumber, '')
  }
  /**
   * Return Purchase Order Invoice Number Sub-Endpoint.
   * @return {Object} 
   */
  invoiceNumber() {
    return this.hasMany(InvoiceNumberModel)
  }
  /**
   * Map a item to Purchase Order Detail.
   *
   * @param  {Object}  item    The item
   * @return {DetailPurchaseOrderModel}  
   */
  mapDetail = item => new DetailPurchaseOrderModel(item)
  /**
   * { lambda_description }
   *
   * @param      {<type>}  item    The item
   */
  mapInvoice = item => ({
      ...item,
      extra_tax: this.extra_tax,
      invoice_number: this.invoice_number_selected,
      new_subtotal: this.selected_new_net_subtotal,
      iva: this.selected_iva,
      total: this.selected_total,
      global_discount: this.selected_global_discount_amount * -1, // Add new attribute (send negative value)
  })
  /**
   *
   */
  mapInvoiceNumber = ({ invoice_number }) => invoice_number
  /**
   *
   */
  mapInvoiceNumberId = ({ id }) => id
  /**
   *
   */
  reduceNetSubtotal = (total, curr) => total + curr.net_total
  /**
   * Reduces the invoice number.
   *
   * @param      {<type>}  val     The value
   * @param      {<type>}  item    The item
   * @return     {<type>}  { description_of_the_return_value }
   */
  reduceInvoiceNumber = (val, item) => {
    return item.id === this.invoice_number_id ? item.invoice_number : val
  }
  /**
   * Resets the Purchase Order.
   *
   * @return     {Object}  { description_of_the_return_value }
   */
  reset() {
      
    // required data
    this.pch_detail_purchase_orders = this.pch_detail_purchase_orders.map(this.mapDetail)

    // new this
    return this
  }
  /**
   * reset the payment date
   */
  resetPaymentDate() {

    let payment_date = new Date(this.emission_date)

    payment_date.setDate(payment_date.getDate() + this.pch_payment_condition_sum)

    let year  = payment_date.getFullYear()
    let month = payment_date.getMonth() + 1
    let date  = payment_date.getDate()

    this.payment_date = [ year, month, date ].join('-')
  }
  /**
   * Purchase Order Model Resource
   * @type {String}
   */
  resource() {
    return 'pch_purchase_order'
  }
  /**
   *
   */
  toInvoice() {
    return new PurchaseInvoiceModel(this.mapInvoice(this))
  }
  /**
   * Returns an invoice number representation of the object.
   * @return {Object}  Invoice number representation of the object.
   */
  toInvoiceNumber() {
    return {
      invoice_number: this.new_invoice_number,
    }
  }
}
